import {
  createConnection,
  getCommunicatorSession,
  EVENT_NAMES,
} from "@rubicon/iframe-communicator";

window.__communicatorSession = null;
window.__streamingContextId = null;

function isInIframe() {
  return window.self !== window.top;
}

function createIframeConnection() {
  if (!isInIframe() || !document.referrer) {
    return;
  }
  const parentWindow = new URL(document.referrer).origin;
  createConnection(parentWindow);
  window.__communicatorSession = getCommunicatorSession();
  subscribeToOrgChange();
}

function setStreamingContextId(org) {
  try {
    if (!org || !Array.isArray(org.contexts)) {
      return null;
    }
  
    const streamingContext = org.contexts.find(
      (context) => context && context.platformName === "streaming" && context.contextId
    );
  
    return streamingContext ? streamingContext.contextId : null;
  } catch (e) {
    return null;
  }
}

function handleOrgChange(org) {
  window.__streamingContextId = setStreamingContextId(org);
}

function subscribeToOrgChange() {
  const session = window.__communicatorSession;
  if (!session) {
    return;
  }

  session.subscribe(EVENT_NAMES.ORG_CHANGE, handleOrgChange);
}

function waitForConnection(timeout = 5000) {
  return new Promise((resolve, reject) => {
    const session = window.__communicatorSession;

    if (session.isConnected) {
      return resolve();
    }

    function onConnect () {
      session.off("connected", onConnect);
      session.off("reconnected", onConnect);
      resolve();
    }

    session.on("connected", onConnect);
    session.on("reconnected", onConnect);

    setTimeout(() => {
      session.off("connected", onConnect);
      session.off("reconnected", onConnect);
      reject(new Error("Timed out waiting for connection"));
    }, timeout);
  });
}


async function emitChangeRoute(event) {
  if (!window.__communicatorSession) {
    console.warn("No communicator session is available");
    return;
  }
  try {
    await waitForConnection();
    window.__communicatorSession.emitEvent("NAVIGATE", event);
  } catch (e) {
    console.warn("NAVIGATE event is not sent:", e);
  }
}

window.emitUpdateSettings = async () => {
  if (!window.__communicatorSession) {
    console.warn("No communicator session is available");
    return;
  }
  try {
    await waitForConnection();
    window.__communicatorSession.runCommand("refetchSettings");
  } catch(e) {
    console.warn("refetchSettings command can't be executed:", e);
  }
};

function emitHistoryChanges() {
  if (!isInIframe()) {
    return;
  }

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  let lastHref = location.href;

  function notifyParentIfChanged() {
    const currentHref = location.href;
    if (currentHref !== lastHref) {
      emitChangeRoute({
        accountId: window.__vd_config.userAccount,
        href: location.pathname + location.search + location.hash,
      });
      lastHref = currentHref;
    }
  }

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    notifyParentIfChanged();
  };

  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    notifyParentIfChanged();
  };

  window.addEventListener("popstate", notifyParentIfChanged);
}

window.setupIframeNavigationInterceptor = () => {
  if (!isInIframe()) {
    return;
  }
  createIframeConnection();
  emitHistoryChanges();
  emitChangeRoute({
    accountId: window.__vd_config.userAccount,
    href: location.pathname + location.search + location.hash,
  });
};
